<template>
    <div class="campaign-builder-modal">
        <DsModal
            is-open
            size="lg"
            :show-close="!isEditable"
            class="integration-modal"
            data-qa="integration-modal"
            :title="cell.value.name"
            @close="closeModal"
        >
            <template #default>
                <iframe
                    v-if="isEditable"
                    ref="iframeRef"
                    class="external-config-frame"
                    :src="iframeUrl"
                />
                <div v-else>
                    {{ $t('funnel.edit.process.integration.summary') }}
                </div>
            </template>
        </DsModal>
    </div>
</template>

<script>
import {
    getActionConfigData,
    updateActionConfigData,
} from '../../../integrations/integration-action-utils';

const MESSAGE_TYPES = {
    LOADED: 'loaded',
    SAVE: 'save',
    CLOSE: 'close',
    STATUS: 'status',
};

export default {
    props: {
        enabledIntegrations: {
            type: Array,
            default: () => [],
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                },
            }),
        },
    },
    emits: ['update-cell-value', 'close-modal'],
    data() {
        return {
            httpRequestConfig: {},
        };
    },

    computed: {
        iframeUrl() {
            const url = new URL(this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId)?.url);

            return url.toString();
        },

        isEditable() {
            return this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId)?.editable;
        },
    },

    async mounted () {
        window.addEventListener('message', this.receiveMessage);

        this.httpRequestConfig = await this.fetchActionConfigData();
    },

    beforeUnmount () {
        window.removeEventListener('message', this.receiveMessage);
    },

    methods: {
        receiveMessage (event) {
            const { data: { type } } = event;

            if (type === MESSAGE_TYPES.CLOSE) {
                this.closeModal();
            } else if (type === MESSAGE_TYPES.SAVE) {
                const {
                    data: {
                        ready,
                        // eslint-disable-next-line camelcase
                        http_request,
                    },
                } = event;

                this.updateConfig(http_request, ready);
            } else if (type === MESSAGE_TYPES.LOADED) {
                const message = {
                    type: 'init',
                    ready: this.cell.isReady ? this.cell.isReady : 0,
                    // eslint-disable-next-line camelcase
                    http_request: this.httpRequestConfig,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            } else if (type === MESSAGE_TYPES.STATUS) {
                const { data: { ready } } = event;

                this.updateReady(ready);
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },

        async updateConfig(httpRequestConfig, parametersDeleted, isReady) {
            const updatedCell = { ...this.cell };

            try {
                const updateIntegrationActionRequest = {
                    http_request_config_id: this.cell.value.httpRequestConfigId,
                    http_request: httpRequestConfig,
                };

                await updateActionConfigData(updateIntegrationActionRequest);

                this.$emit('update-cell-value', { cell: updatedCell, isReady });
            } catch (e) {
                const message = {
                    type: 'error',
                    errorMessage: e.response.data,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            }
        },

        updateReady(isReady) {
            const updatedCell = { ...this.cell };

            this.$emit('update-cell-value', { cell: updatedCell, preventClose: true, isReady });
        },

        async fetchActionConfigData() {
            return getActionConfigData(this.cell.value.httpRequestConfigId);
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-modal {
    padding: 0;
}

.external-config-frame {
    width: 100%;
    height: 75vh;
}
</style>
